export const aPictureDataType = (data)=>{
  return getInterface.post('all/openApi/aPictureDataType', data);
}
export const aPictureDataExport = (data)=>{
  return getInterface.post('all/openApi/aPictureDataExport', data);
}